<div class="tool-container">
  <div class="tool-list-panel">
    <div class="search-bar-container">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search tools</mat-label>
        <input matInput [(ngModel)]="searchQuery" (ngModelChange)="filterTools()" placeholder="Search by name or description">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <div class="tools-list">
      <mat-card *ngFor="let tool of filteredTools" 
                [class.selected]="selectedTool?._id === tool._id"
                (click)="selectTool(tool)">
        <mat-card-header>
          <mat-card-title>{{tool.name}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{tool.description || 'No description available'}}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="tool-details" *ngIf="selectedTool">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{selectedTool.name}}</mat-card-title>
        <mat-card-subtitle *ngIf="selectedTool.description">{{selectedTool.description}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="tool-id">
          <span class="label">Tool ID:</span> {{selectedTool._id}}
        </div>

        <!-- Run View -->
        <div *ngIf="!isEditMode">
          <div class="parameters-container" *ngIf="selectedTool.kvParameters?.length">
            <h3>Parameters</h3>
            
            <div *ngFor="let kvParam of selectedTool.kvParameters" class="parameter-row">
              <div class="parameter-info">
                <div class="parameter-name">
                  {{kvParam.key}}
                  <span class="required-badge" *ngIf="isRequired(kvParam.key)">*</span>
                </div>
                <div class="parameter-description" *ngIf="kvParam.value?.description">
                  {{kvParam.value.description}}
                </div>
                <div class="parameter-type" *ngIf="kvParam.value?.type">
                  Type: {{kvParam.value.type}}
                </div>
                <div class="parameter-enum" *ngIf="kvParam.value?.enum?.length">
                  Options: {{kvParam.value.enum.join(', ')}}
                </div>
              </div>
              <div class="parameter-input">
                <mat-form-field appearance="outline">
                  <mat-label>{{kvParam.key}}</mat-label>
                  <input matInput [(ngModel)]="paramValues[kvParam.key]" 
                        [placeholder]="'Enter ' + kvParam.key"
                        [required]="isRequired(kvParam.key)">
                  <mat-hint *ngIf="kvParam.value?.type === 'array'">Enter JSON array format</mat-hint>
                  <mat-hint *ngIf="kvParam.value?.type === 'object'">Enter JSON object format</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="tool-actions">
            <button mat-raised-button color="primary" (click)="runTool()" [disabled]="isRunning">
              <mat-icon>play_arrow</mat-icon>
              Run Tool
            </button>
            <button mat-raised-button color="accent" (click)="toggleEditMode()">
              <mat-icon>edit</mat-icon>
              Update
            </button>
          </div>

          <div class="result-container" *ngIf="toolResult || isRunning">
            <mat-progress-spinner *ngIf="isRunning" mode="indeterminate" diameter="40" class="result-spinner"></mat-progress-spinner>
            
            <div class="result-content" *ngIf="toolResult && !isRunning">
              <h3>Result</h3>
              <div class="markdown-body" [innerHTML]="formatOutput(toolResult)"></div>
            </div>
          </div>
        </div>

        <!-- Edit View -->
        <div *ngIf="isEditMode" class="edit-form">
          <h3>Edit Tool</h3>
          
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput [(ngModel)]="selectedTool.description" rows="2"></textarea>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>UI Description</mat-label>
            <textarea matInput [(ngModel)]="selectedTool.uiDescription" rows="2"></textarea>
          </mat-form-field>

          <h4>Parameters</h4>
          <div *ngFor="let kvParam of paramJsonValues; let i = index" class="parameter-edit-row">
            <mat-form-field appearance="fill" class="parameter-key">
              <mat-label>Parameter Key</mat-label>
              <input matInput [(ngModel)]="paramJsonValues[i].key">
            </mat-form-field>
            
            <mat-form-field appearance="fill" class="parameter-json" style="flex: 3">
              <mat-label>Parameter Definition (JSON)</mat-label>
              <textarea matInput [(ngModel)]="paramJsonValues[i].valueJson" rows="5"></textarea>
              <mat-error *ngIf="paramJsonValues[i].error">Invalid JSON: {{paramJsonValues[i].error}}</mat-error>
              <mat-hint>Enter valid JSON for the parameter definition</mat-hint>
            </mat-form-field>
            
            <button mat-icon-button color="warn" (click)="removeParam(i)" matTooltip="Remove parameter">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          
          <button mat-button color="primary" (click)="addParam()" class="add-param-button">
            <mat-icon>add</mat-icon> Add Parameter
          </button>

          <!-- Factory Parameters Section -->
          <h4>Factory Parameters</h4>
          <div *ngFor="let factoryParam of factoryParamJsonValues; let j = index" class="parameter-edit-row">
            <mat-form-field appearance="fill" class="parameter-key">
              <mat-label>Parameter Key</mat-label>
              <input matInput [(ngModel)]="factoryParamJsonValues[j].key">
            </mat-form-field>
            <mat-form-field appearance="fill" class="parameter-json" style="flex: 3">
              <mat-label>Parameter Definition (JSON)</mat-label>
              <textarea matInput [(ngModel)]="factoryParamJsonValues[j].valueJson" rows="5"></textarea>
              <mat-error *ngIf="factoryParamJsonValues[j].error">Invalid JSON: {{factoryParamJsonValues[j].error}}</mat-error>
              <mat-hint>Enter valid JSON for the parameter definition</mat-hint>
            </mat-form-field>
            <button mat-icon-button color="warn" (click)="removeFactoryParam(j)" matTooltip="Remove parameter">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <button mat-button color="primary" (click)="addFactoryParam()" class="add-param-button">
            <mat-icon>add</mat-icon> Add Factory Parameter
          </button>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Required Parameters (comma-separated)</mat-label>
            <input matInput [(ngModel)]="requiredParamsStr" placeholder="param1,param2">
          </mat-form-field>

          <div class="checkbox-group">
            <mat-checkbox [(ngModel)]="selectedTool.promptCache">
              Prompt Cache
            </mat-checkbox>

            <mat-checkbox [(ngModel)]="selectedTool.supportStream">
              Support Stream
            </mat-checkbox>

            <mat-checkbox [(ngModel)]="selectedTool.endConversation">
              End Conversation
            </mat-checkbox>

            <mat-checkbox [(ngModel)]="selectedTool.asAgentAsync">
              asAgentAsync
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="selectedTool.manualUpdate">
              Manual Update
            </mat-checkbox>
          </div>

          <mat-form-field appearance="fill" class="full-width" *ngIf="agents && agents.length">
            <mat-label>Associated Agent</mat-label>
            <mat-select [(ngModel)]="selectedTool.asAgent">
              <mat-option [value]="null">None</mat-option>
              <mat-option *ngFor="let agent of agents" [value]="agent._id">
                {{agent.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="selectedTool.extraObj && selectedTool.extraObj['type'] === 'llm'">
            <h4>LLM Parameters</h4>
            
            <mat-form-field appearance="fill" class="full-width" style="position: relative;">
              <mat-label>System Prompt</mat-label>
              <textarea matInput [(ngModel)]="selectedTool.extraObj['systemPrompt']" rows="4"></textarea>
              <button mat-icon-button type="button" style="position: absolute; top: 8px; right: 8px; z-index: 2;" (click)="openSystemPromptModal()" matTooltip="Show Markdown Preview">
                <mat-icon>visibility</mat-icon>
              </button>
            </mat-form-field>
            
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>LLM Vendor</mat-label>
              <mat-select [(ngModel)]="selectedTool.extraObj['llmVendor']" (ngModelChange)="onVendorChange($event)">
                <mat-option *ngFor="let vendor of vendors" [value]="vendor">
                  {{vendor}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>LLM Model</mat-label>
              <mat-select [(ngModel)]="selectedTool.extraObj['llmModel']" [disabled]="!selectedTool.extraObj['llmVendor']">
                <mat-option *ngFor="let model of models[selectedTool.extraObj['llmVendor']] || []" [value]="model">
                  {{model}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Temperature</mat-label>
              <input matInput type="number" [(ngModel)]="selectedTool.extraObj['llmTemperature']" min="0" max="2" step="0.1">
              <mat-hint>Value between 0 and 2</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Reasoning Effort</mat-label>
              <mat-select [(ngModel)]="selectedTool.extraObj['llmReasoningEffort']">
                <mat-option [value]="null">Unspecified</mat-option>
                <mat-option value="minimal">minimal</mat-option>
                <mat-option value="low">low</mat-option>
                <mat-option value="medium">medium</mat-option>
                <mat-option value="high">high</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <div class="tool-actions">
            <button mat-raised-button color="warn" (click)="toggleEditMode()">
              Cancel
            </button>
            <button mat-raised-button color="primary" (click)="saveToolChanges()">
              Save
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>